import React from 'react'

const Faq = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className='container'>
      {block.image && (
        <img src={block.image} alt={block.image_alt_text} title={block.image_alt_text} />
      )}

      <div className='row'>
        <div className='col-lg-6 offset-lg-5 col-md-8 offset-md-4'>
          <div className='faq-wr'>
            {block.items.map((item, index) => {
              return <div key={index} className='faq'>
                {item.question && ( <h4 dangerouslySetInnerHTML={{__html: item.question}}></h4> )}
                {item.answer && ( <p dangerouslySetInnerHTML={{__html: item.answer}}></p> )}
              </div>
            })}
          </div>
        </div>
      </div>

    </div>
  </section>
)

export default Faq
